export const version = "hdnode/5.0.9";
//# sourceMappingURL=_version.js.map